import { useEffect, useState } from "react";
import { Link } from "react-router-dom";
import { ArrowRight, Gift } from "lucide-react";
import { fetchResources } from "@/lib/cmsApi";
import ResourceCard from "@/components/resources/ResourceCard";
import { FadeUp } from "@/components/site/Reveal";

const FreeResources = () => {
    const [resources, setResources] = useState(null);

    useEffect(() => {
        fetchResources()
            .then((all) => {
                const featured = all.filter((r) => r.featured);
                const rest = all.filter((r) => !r.featured);
                setResources([...featured, ...rest].slice(0, 3));
            })
            .catch(() => setResources([]));
    }, []);

    // Hide the section entirely until there is something published
    if (!resources || resources.length === 0) return null;

    return (
        <section className="px-5 py-14" data-testid="home-free-resources">
            <div className="mx-auto max-w-6xl">
                <FadeUp>
                    <p className="eyebrow flex items-center justify-center gap-2">
                        <Gift className="h-4 w-4" /> Free resources
                    </p>
                    <h2 className="font-display mx-auto mt-4 max-w-3xl text-center text-3xl text-white sm:text-5xl">
                        Practical fitness &amp; nutrition resources —{" "}
                        <span className="bg-gradient-to-r from-[#45d1f5] to-[#f0356f] bg-clip-text text-transparent">
                            completely free
                        </span>
                    </h2>
                    <p className="mx-auto mt-4 max-w-xl text-center text-sm leading-relaxed text-[#9fb0c7]">
                        Real meal plans, workout guides and checklists from Coach Uzair. No account
                        needed — take the value, keep it forever.
                    </p>
                </FadeUp>
                <FadeUp delay={0.1}>
                    <div className="mt-10 grid gap-5 sm:grid-cols-2 lg:grid-cols-3" data-testid="home-resources-grid">
                        {resources.map((r) => <ResourceCard key={r.id} resource={r} />)}
                    </div>
                </FadeUp>
                <FadeUp delay={0.15}>
                    <div className="mt-10 text-center">
                        <Link to="/resources" data-testid="home-resources-all" className="btn-ghost">
                            View All Free Resources <ArrowRight className="h-4 w-4" />
                        </Link>
                    </div>
                </FadeUp>
            </div>
        </section>
    );
};

export default FreeResources;
